<section class="notification-popover tw:grid tw:rounded-app-xl tw:bg-app-white tw:shadow-app-card-soft tw:overflow-hidden"
  role="dialog"
  [attr.aria-label]="'notification.title' | translate">
  <header class="notification-popover__header tw:items-center tw:justify-between">
    <h2>{{ 'notification.title' | translate }}</h2>

    <div class="notification-popover__header-actions tw:items-center">
      @if (hasUnreadBadge()) {
        <span class="notification-popover__badge tw:inline-flex tw:items-center tw:justify-center tw:rounded-app-pill tw:bg-app-surface-active tw:text-app-text">{{ resolvedUnreadCount() }}</span>
      }

      <button type="button"
        class="notification-popover__close tw:inline-flex tw:items-center tw:justify-center tw:rounded-app-pill tw:text-app-link tw:cursor-pointer"
        (click)="onClose()"
        [attr.aria-label]="'common.close' | translate">
        <ion-icon name="close-outline"></ion-icon>
      </button>
    </div>
  </header>

  <div class="notification-popover__body tw:overflow-y-auto">
    @if (items().length > 0) {
      <ul class="notification-popover__list">
        @for (item of items(); track $index) {
          <li>
            <button type="button"
              class="notification-popover__item tw:w-full tw:grid tw:items-center tw:gap-app-3 tw:text-left tw:cursor-pointer"
              [class.notification-popover__item--unread]="item.unread"
              (click)="onSelect(item)">
              <span class="notification-popover__icon tw:inline-flex tw:items-center tw:justify-center tw:rounded-app-lg tw:bg-app-white tw:text-app-link"
                aria-hidden="true">
                <ion-icon [name]="iconName(item)"></ion-icon>
              </span>

              <span class="notification-popover__content tw:min-w-0 tw:grid">
                <span class="notification-popover__title tw:text-app-text tw:leading-app-snug tw:overflow-hidden tw:text-ellipsis tw:whitespace-nowrap">{{ item.title }}</span>

                @if (item.subtitle) {
                  <span class="notification-popover__subtitle tw:text-app-muted tw:leading-app-snug tw:overflow-hidden tw:text-ellipsis tw:whitespace-nowrap">{{ item.subtitle }}</span>
                }
              </span>

              <span class="notification-popover__meta tw:inline-flex tw:items-center tw:gap-app-2">
                <span class="notification-popover__time tw:text-app-muted-soft tw:leading-app-snug tw:whitespace-nowrap">{{ item.timeLabel }}</span>

                @if (item.unread) {
                  <span class="notification-popover__unread-dot tw:bg-app-primary"
                    aria-hidden="true"></span>
                }
              </span>
            </button>
          </li>
        }
      </ul>
    } @else {
      <p class="notification-popover__empty tw:text-app-muted tw:text-app-sm tw:text-center">{{ 'notification.empty' | translate }}</p>
    }
  </div>
</section>
